<template>
    <div class="contain">
        <ManageHeaderMenu></ManageHeaderMenu>
        <div class="main">
            <ManageMenu defaultActive="1-5"></ManageMenu>
            <div class="content">
                <div class="content-title">
                    <span>{{ pageName }}：数量 {{ pagination.total }}</span>
                    <el-button style="margin-left: auto;" class="content-title-button" @click="refresh">刷新数据</el-button>
                    <el-button class="content-title-button" @click="drawer = true">添加数据</el-button>
                </div>
                <div style="padding: 20px;">
                    <el-table :data="tableData" border class="custom-table">
                        <el-table-column prop="platform" label="平台名称">
                        </el-table-column>
                        <el-table-column prop="username" label="账号">
                        </el-table-column>
                        <el-table-column prop="password" label="密码">
                        </el-table-column>
                        <el-table-column prop="info" label="备注信息">
                        </el-table-column>
                        <el-table-column prop="link" label="链接地址" align="center">
                            <template slot-scope="scope">
                                <el-link target="_blank" :href="scope.row.link" type="info">访问链接</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button class="table-button" size="mini" @click="updateData(scope.row)">编辑</el-button>
                                <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                                    confirm-button-type="primary" cancel-button-type="info" title="温馨提示：是否确定删除当前数据"
                                    @confirm="deleteData(scope.row)">
                                    <el-button plain type="danger" class="table-button" size="mini"
                                        slot="reference">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div
                        style="background-color: #ffffff; height: 50px; display: flex; align-items: center; margin-top: 20px;">
                        <el-pagination @current-change="changePage" background layout="prev, pager, next"
                            :total="pagination.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-drawer :title="`${pageName} ${form.id == '' ? '添加数据' : '更新数据'}`" style="z-index: 1;" :visible.sync="drawer"
            direction="ltr" :before-close="handleClose">
            <div class="custom-form">
                <el-form :model="form">
                    <el-form-item label="账号">
                        <el-input v-model="form.username" placeholder="请填写账号" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="form.password" placeholder="请填写密码" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="平台名称">
                        <el-input v-model="form.platform" placeholder="请填写平台名称" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="链接地址">
                        <el-input v-model="form.link" placeholder="请填写链接地址" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息">
                        <el-input v-model="form.info" placeholder="请填写备注信息" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div style="display: flex; justify-content: flex-end;">
                    <el-button @click="drawer = false">取消操作</el-button>
                    <el-button type="primary" @click="submit">确定设置</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import ManageHeaderMenu from './ManageHeaderMenu.vue';
import ManageMenu from './ManageMenu.vue';
import Api from "@/apis";

export default {
    data() {
        return {
            pageName: "付费服务账号",
            tableData: [],
            drawer: false,
            pagination: {
                page: 1,
                page_size: 10,
                total: 0,
            },
            form: {
                id: '',
                username: '',
                password: '',
                platform: '',
                link: '',
                info: ''
            }
        };
    },
    methods: {
        handleClose(done) {
            this.clearForm();
            done();
        },
        filterBlank() {
            Object.keys(this.form).forEach(key => {
                if (typeof this.form[key] === 'string') {
                    this.form[key] = this.form[key].trim();
                }
            });
        },
        refresh() {
            this.selectTableData();
        },
        changePage(page) {
            this.pagination.page = page;
            this.selectTableData();
        },
        isFilledForm() {
            for (let key in this.form) {
                if (Object.prototype.hasOwnProperty.call(this.form, key)) {
                    if (this.form[key] === '' && key !== 'id') {
                        return true;
                    }
                }
            }
            return false;
        },
        clearForm() {
            Object.keys(this.form).forEach(key => {
                this.form[key] = '';
            });
        },
        submit() {
            if (this.isFilledForm()) {
                this.$message({ message: "填写数据存在空缺", type: 'warning' });
                return;
            } else {
                this.filterBlank();
            }

            if (this.form.id) {
                Api.updateAccount(this.form).then(res => {
                    if (res.data.code === 200) {
                        this.selectTableData();
                        this.drawer = false;
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this);
                });
            } else {
                Api.insertAccount(this.form).then(res => {
                    if (res.data.code === 200) {
                        this.selectTableData();
                        this.drawer = false;
                        this.$message({ message: res.data.message, type: 'success' });
                    } else {
                        this.$message({ message: res.data.message, type: 'error' });
                    }
                }).catch(() => {
                    Api.feedback(this);
                });
            }
        },
        deleteData(data) {
            Api.deleteAccount({
                id: data.id
            }).then(res => {
                if (res.data.code === 200) {
                    this.selectTableData();
                    this.$message({ message: res.data.message, type: 'success' });
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this);
            });
        },
        updateData(data) {
            this.drawer = true;
            this.form = Object.assign({}, data);
        },
        selectTableData() {
            Api.selectAccount({
                page: this.pagination.page,
                page_size: this.pagination.page_size
            }).then(res => {
                if (res.data.code === 200) {
                    this.$message({ message: res.data.message, type: 'success' });
                    this.tableData = res.data.data.table_data;
                    this.pagination.total = res.data.data.total;
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this);
            });
        }
    },
    mounted() {
        this.selectTableData();
    },
    components: {
        ManageHeaderMenu,
        ManageMenu
    }
};
</script>

<style scoped>
.main {
    justify-content: space-between;
    display: flex;
}

.content {
    flex: 1;
    overflow-y: scroll;
    height: calc(100vh - 60px);
}

.content-title {
    height: 60px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;
    display: flex;
}

.content-title span {
    font-size: 20px;
}

.custom-form {
    padding: 20px;
}

.table-button {
    margin: 0 5px;
    padding: 5px 10px;
}
</style>
